import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { AxiosError, AxiosInstance } from 'axios'

import { recursiveCamelCase } from './helper'
import { EntitySearchType } from './types'
import useAxios from './useAxios'
import useTracking from 'tracking/useTracking'

export default function useGlobalSearch(
  searchTerm: string,
  searchType: string,
  extraProps?: UseQueryOptions<any, any>
) {
  const axios = useAxios()
  const [tracking] = useTracking()

  return useQuery<EntitySearchType[], AxiosError>(
    ['globalSearch', searchTerm],
    () => {
      tracking.AppsGlobalSearch({ searchTerm, searchType })
      return searchEntities(axios, searchTerm)
    },
    {
      enabled: !!searchTerm, // Prevent query if searchString is empty
      refetchOnMount: false,
      ...extraProps,
    }
  )
}

export const searchEntities = async (
  axios: AxiosInstance,
  searchString: string
): Promise<EntitySearchType[]> => {
  return axios
    .get(`/search/universal/?search_term=${encodeURIComponent(searchString)}`)
    .then((res) => recursiveCamelCase(res.data))
}
